import { QUOTES } from "@/data/content";
import { Quote } from "lucide-react";

export const Quotes = () => (
  <section className="border-t border-white/5 bg-[#B12A2A] py-20">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-2">
        {QUOTES.map((q, i) => (
          <div key={i} className="flex gap-4" data-testid={`quote-${i}`}>
            <Quote className="h-8 w-8 flex-none text-white/40" />
            <p className="font-heading text-xl font-medium leading-snug text-white sm:text-2xl">
              {q}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
